import React from 'react'
import { usePageTemplateContext } from '../PageTemplate/usePageTemplateContext'
import { StyledModal, StyledPageAside } from './PagePaneTemplate.styles'
import type { PagePaneTemplateProps } from './PagePaneTemplate.types'

export const PagePaneTemplate = React.forwardRef<
  HTMLDivElement,
  PagePaneTemplateProps
>(function PagePane(props, ref) {
  const { labelId, open, onClose, children } = props
  const { isMobile } = usePageTemplateContext()

  if (isMobile) {
    return (
      <StyledModal
        ref={ref}
        aria-labelledby={labelId}
        open={open}
        onClickOverlay={onClose}
        placement="center"
        role="dialog"
        width="md"
      >
        {children}
      </StyledModal>
    )
  }

  return (
    <StyledPageAside ref={ref} open={open}>
      {children}
    </StyledPageAside>
  )
})
